<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Puzzle-Fences-Generator-Root',
};
</script>
